import { ReactElement, useEffect, useRef } from 'react';
import {
    UIButton,
    UIInlineAlert,
    UILoadingState,
    UISpacer,
    UIText
} from '@/ui';
import styles from './verify-new-email.module.scss';
import { useNavigate } from 'react-router';
import { useMeTranslation } from '../hooks';
import { useVerifyNewEmailAction } from '../actions';

type VerifyNewEmailProps = {
    token: string;
};
export function VerifyNewEmail(props: VerifyNewEmailProps): ReactElement {
    const { token } = props;

    const navigate = useNavigate();

    const { t } = useMeTranslation();

    const { verifyNewEmail, loading, error } = useVerifyNewEmailAction();
    const hasRun = useRef(false);
    useEffect(() => {
        if (!hasRun.current) {
            hasRun.current = true;
            verifyNewEmail({ token }).catch(() => {}); // Error handled in hook
        }
    }, [verifyNewEmail, token]);

    if (error && !loading) {
        return (
            <div className={styles.container}>
                <UIInlineAlert text={error} />
            </div>
        );
    }

    if (loading) {
        return (
            <div className={styles.container}>
                <UILoadingState
                    text={t('components.verify_new_email.loading')}
                />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <UIText>{t('components.verify_new_email.success')}</UIText>
            </div>
            <UISpacer multiplier={2} />
            <UIButton
                onClick={() => {
                    void navigate('/');
                }}
            >
                {t('shared.labels.continue')}
            </UIButton>
        </div>
    );
}
